import api from '@api';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getOverviewOrdersGridFetchSuccess, getOverviewOrdersGridFetchFailure } from './reducer';
import { OrdersGridResType } from 'src/types/ordersGrid';
import { ORDER_GRID_URL } from '../ordersGrid/sagas';

export const ORDERS_REQUEST_DATA = {
    filters: [[{ column: 'STATUS', operator: 'in', value: ['productsNotAvailable', 'incorrect'] }]],
    sorts: [{ column: 'ID', direction: 'ASC' }],
    page: 1,
    items: 1000,
    columns: ['ESHOP_ORDER_ID', 'ID', 'STATUS', 'INCORRECT_AT', 'TIMESTAMP', 'RECIPIENT_NAME'],
};

const getOrdersRequest = async () => {
    const res = await api('post', ORDER_GRID_URL, ORDERS_REQUEST_DATA);
    return res.data.data;
};
function* getOverviewOrdersGridFetch() {
    try {
        const response: OrdersGridResType = yield call((): any => getOrdersRequest());
        yield put(getOverviewOrdersGridFetchSuccess(response));
    } catch (error) {
        yield put(getOverviewOrdersGridFetchFailure({ error }));
    }
}

export function* getOverviewOrdersGridFetchWatch() {
    yield takeEvery('overviewOverviewOrdersGrid/getOverviewOrdersGridFetch', getOverviewOrdersGridFetch);
}
